import { useContext, useCallback } from "react";
import { Stack, Typography, Grid2 as Grid } from "@mui/material";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import BoyIcon from "@mui/icons-material/Boy";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import ManIcon from "@mui/icons-material/Man";
import ElderlyIcon from "@mui/icons-material/Elderly";
import { AppContext } from "../App";
import { ImageButton } from "../components/ImageButton";
import { usePostHog } from "@posthog/react";

const AGE_GROUPS = [
  { label: "Infants", value: "Infants (0-2)", Icon: BabyChangingStationIcon, subText: "Ages 0-2" },
  { label: "Children", value: "Children (3-12)", Icon: EscalatorWarningIcon, subText: "Ages 3-12" },
  { label: "Adolescents", value: "Adolescents (13-17)", Icon: BoyIcon, subText: "Ages 13-17" },
  { label: "Adults", value: "Adults (18-64)", Icon: ManIcon, subText: "Ages 18-64" },
  { label: "Older Adults", value: "Older Adults (65+)", Icon: ElderlyIcon, subText: "Ages 65+" },
];

export function PopulationServed() {
  const { form, updateForm } = useContext(AppContext);
  const posthog = usePostHog();

  const handleSubmit = useCallback(
    (value: string) => {
      updateForm({ providerAgeGroups: value });
      posthog?.capture("age_group_selected", { age_group: value });
    },
    [updateForm, posthog]
  );

  return (
    <Stack direction="column" spacing={2} alignItems="center">
      <Typography variant="h6">I am seeking a provider who works with:</Typography>
      <Grid container columns={{ xs: 1, sm: 2, md: 5 }} justifyContent="center" spacing={2}>
        {AGE_GROUPS.map(({ label, value, Icon, subText }) => (
          <Grid key={value}>
            <ImageButton
              label={label}
              image={<Icon />}
              onClick={() => handleSubmit(value)}
              subText={subText}
              selected={form.providerAgeGroups === value}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
